export default __webpack_public_path__ + "static/media/KZ.T.08.Е0663 black.5216299a.svg";